export default {
    appName: 'База знаний',
    installTitle: 'Установка приложения',
    install: 'Установить',
    installEntity: 'Общая база',
    installSectionName: 'База знаний',
    installPropTags: 'Теги',
    installPropMain: 'Показывать на главной',

    IndexLast: 'Последние добавленные',

    Section: 'Раздел',
    addSection: 'Создать подраздел',
    AddSectionTitle: 'Добавить новый раздел',
    EditSectionTitle: 'Редактировать раздел',
    AddSectionFormName: 'Название раздела',
    AddSectionFormParent: 'Сделать подразделом',
    AddSectionFormMain: 'Корневой раздел',

    deleteConfirm: 'Подтверждение удаления',
    restoreConfirm: 'Подтверждение восстановления',
    sectionDeleteDanger: 'Раздел будет удален со всеми подразделами и элементами',
    sectionSoftDeleteDanger: 'раздел будет помещён в корзину со всеми подразделами и статьями.',
    sectionSoftDeleteRestore: 'Раздел будет восстановлен вместе со всеми дочерними разделами и элементами',
    elementDeleteDanger: 'Элемент будет безвозвратно удален',
    elementSoftDeleteDanger: 'статья будет помещена в корзину.',
    elementSoftDeleteRestore: 'Элемент будет восстановлен',

    crossArticleBadge: 'Сквозная статья',
    crossArticlePlacementsHint: 'Статья показывается также в разделах:',
    crossArticleSoftDeleteWarning: 'Статья сквозная: вместе с ней она исчезнет из разделов, где размещена —',
    crossArticleDeleteWarning: 'Статья сквозная: её размещения будут удалены безвозвратно —',

    elementMoveConfirm: 'Подтверждение перемещения',
    elementCopyConfirm: 'Копирование элемента',
    elementMoveDanger: 'Элемент будет безвозвратно перемещен. Публичные ссылки отменены',
    elementCopyProcess: 'Копирование...',
    elementCopySuccess: 'Готово!',
    elementCopyError: 'Ошибка!',
    tryAgainMessage: 'Попробовать снова',

    AddElement: 'Создать статью',
    AddElementTitle: 'Добавить новую запись',
    AddElementFormElementName: 'Название элемента',
    AddElementFormChangeSection: 'Выберите категорию',
    AddElementFormText: 'Текст записи',
    AddElementFormPreivewText: 'Описание',
    AddElementTags: 'Добавить теги',
    AddElementSort: 'Порядок сортировки',
    AddElementDateActiveFrom: 'Активность с',
    AddElementDateActiveTo: 'Активность до',

    requiredField: 'Поля, обязательные для заполнения',

    element404: 'Элемент не найден или доступ к нему запрещен',
    sectionLoadFailed: 'Не удалось загрузить статьи раздела. Попробуйте обновить страницу.',

    chunkLoading: 'Загрузка',
    chunkLoadFailed: 'Не удалось загрузить эту часть страницы',
    chunkLoadRetry: 'Обновить страницу',

    settings: 'Настройки базы:',
    userRights: 'Права пользователей',
    settingsTabSettings: 'Настройки',
    settingsTabLogActions: 'Лог действий',
    settingsTabLogPublicLink: 'Публичные разделы/статьи',
    removeRight: 'Удалить право доступа',
    addModer: 'Добавить',

    accessD: 'Запрещен',
    accessR: 'Чтение',
    accessW: 'Запись',
    accessX: 'Управление',

    name: 'Название',
    save: 'Сохранить и выйти',
    cancel: 'Отменить',
    close: 'Закрыть',
    created: 'Создано',
    detail: 'Детально',
    edit: 'Редактировать',
    move: 'Переместить',
    copy: 'Копировать',
    changeAuthor: 'Сменить автора',
    backup: 'Бэкап',
    editTitle: 'Редактирование элемента',
    remove: 'Удалить',
    restore: 'Восстановить',
    search: 'Искать',
    searchText: 'Поиск',
    searchResult: 'Результаты поиска',
    searchResultEmptyMessage: 'По вашему запросу ничего не найдено',
    aiAnswerTitle: 'ИИ-ответ',
    aiAnswerLoading: 'Ответ ИИ загружается...',
    aiAnswerExpand: 'Показать полностью',
    aiAnswerCollapse: 'Свернуть',
    searchRelatedArticlesTitle: 'Статьи по теме',
    searchOtherResultsTitle: 'Остальные результаты',
    index: 'Главная',
    downloadPdf: 'Скачать статью в pdf',
    print: 'Распечатать',
    readBtn: 'Я прочитал!',
    readBtnOk: 'Прочитано',
    unreadBtn: 'Отменить прочтение',
    unreadConfirmTitle: 'Подтверждение отмены',
    unreadConfirmText: 'Убрать отметку о прочтении статьи?',
    unreadConfirmAction: 'Да, убрать',
    articleNotHelpedBtn: 'Не помогло',
    articleNotHelpedBtnOk: 'Автор уведомлен',
    articleNotHelpedBtnHint: 'Нажмите, если содержимое статьи вам не помогло, автор статьи получит уведомление об этом.',
    testsBlockTitle: 'Проверка знаний',
    testRequiredLabel: 'Обязателен для ознакомления',
    testOptionalLabel: 'Самопроверка',
    testPassedLabel: 'Сдан',
    testNotPassedLabel: 'Не сдан',
    testPassBtn: 'Пройти',
    testRetakeBtn: 'Пройти снова',
    testGateRequiredMessage: 'Чтобы отметить ознакомление, пройдите тест: {tests}',
    testGateRequiredGenericMessage: 'Чтобы отметить ознакомление, пройдите тест по статье',
    testGateForbiddenMessage: 'Недостаточно прав на статью',
    testGateFailedMessage: 'Не удалось отметить ознакомление',
    testGateUnsetFailedMessage: 'Не удалось снять отметку об ознакомлении',
    testNoQuestionsMessage: 'В тесте пока нет вопросов — обратитесь к администратору базы знаний.',
    testLoadError: 'Не удалось загрузить тест: {reason}',
    testAttemptLoadError: 'Не удалось загрузить прогресс прохождения теста: {reason}',
    testStartError: 'Не удалось начать тест: {reason}',
    testDeleteError: 'Не удалось удалить тест: {reason}',
    testAssignError: 'Не удалось назначить тест: {reason}',
    testAssignNoQuestionsError: 'В тесте нет вопросов. Добавьте хотя бы один вопрос, прежде чем назначать тест сотрудникам.',
    testAssignListLoadError: 'Не удалось загрузить список назначенных сотрудников: {reason}',
    testResultsLoadError: 'Не удалось загрузить результаты теста: {reason}',
    relatedArticlesDefaultTitle: 'Связанные статьи',
    relatedArticlesTitleLabel: 'Заголовок блока связанных статей',
    relatedArticlesBaseLabel: 'База знаний для связанных статей',
    relatedArticlesLabel: 'Связанные статьи',

    emptyList: 'Список пуст',
    accessLink: 'Получить публичную ссылку',
    accessLinkPublished: 'Скопировать публичную ссылку',
    unpublishCommonLink: 'Удалить публичную ссылку',

    elementViewViewHistory: 'История изменений',
    elementViewChat: 'Обсудить в чате',
    ElementSetShowOnMainPage: 'Показывать на главной',
    ElementRemoveFromMainPage: 'Не показывать на главной',
    elementSetRequireRead: 'Добавить на ознакомление',
    elementSetRequireReadConfirm: 'Добавить на ознакомление',
    elementSetRequireReadText: 'Выберите отделы либо конкретных сотрудников',
    setRequireReadText: 'Назначить',
    setRequireReadBreadcrumbText: 'Статьи на ознакомление',
    reportRequireReadBreadcrumbText: 'Отчет по статьям на ознакомление',
    elementSubscribeArticleUpdated: 'Подписаться на изменение статьи',
    elementUnsubscribeArticleUpdated: 'Отписаться от изменения статьи',
    moveToDraftFromView: 'Перенести в черновики',
    publishDraftFromView: 'Опубликовать из черновика',

    testAssignDialogTitle: 'Назначить на прохождение теста',
    testAssignListDialogTitle: 'Список пользователей',
    testAssignListDialogDescription: 'На тест назначены',

    appSettingsMenuLink: 'Настройки приложения',
    testsMenuLink: 'Тесты',
    requireReadMenuLink: 'На ознакомление',
    favoritesMenuLink: 'Избранное',
    appSettingsTabCommon: 'Общее',
    appSettingsTabSearch: 'Поиск',
    appSettingsTabTests: 'Тесты',
    appSettingsTabCustomHeader: 'Шапка',
    appSettingsTabStyles: 'Стили',
    appSettingsTabDefaultAccess: 'Права пользователей',
    appSettingsTabTariff: 'Тариф',
    appSettingsTabAdministration: 'Администрирование',
    appSettingsV3Title: 'Настройки приложения',
    appSettingsV3BackToBase: 'Вернуться в базу',
    appSettingsTabLogging: 'Логирование',
    settingsSave: 'Сохранить',
    settingsSaved: 'Настройки сохранены',
    settingsSaveFailed: 'Не удалось сохранить настройки',
    appSettingsTabDefaultAccessDesc: 'Добавьте права по умолчанию для новых баз.',
    customHeaderShowCustomHeader: 'Показывать пользовательскую шапку в публичных ссылках',
    customHeaderInsertHtml: 'Вставьте HTML-код шапки',
    customHeaderInsertCss: 'Вставьте CSS-код шапки',
    commonSettingsActivateFeatureFlagTests: 'Активировать функционал тестов',
    testAccessSettingsDescription: 'Настройка прав на управление тестами. По умолчанию администраторы имеют полные права на управление тестами.',

    dateFormatPluginYearFormatYy: "Год в двух цифрах (например, 23)",
    dateFormatPluginYearFormatYyyy: "Год в четырех цифрах (например, 2023)",
    dateFormatPluginMonthFormatM: "Номер месяца без ведущего нуля (например, 1)",
    dateFormatPluginMonthFormatMm: "Номер месяца с ведущим нулем (например, 01)",
    dateFormatPluginDayFormatD: "День месяца без ведущего нуля (например, 9)",
    dateFormatPluginDayFormatDd: "День месяца с ведущим нулем (например, 09)",
    dateFormatPluginHourFormatHh: "Часы в 24-часовом формате с ведущим нулем (например, 05)",
    dateFormatPluginHourFormatH: "Часы в 24-часовом формате без ведущего нуля (например, 5)",
    dateFormatPluginHourFormathh: "Часы в 12-часовом формате с ведущим нулем (например, 01)",
    dateFormatPluginHourFormath: "Часы в 12-часовом формате без ведущего нуля (например, 1)",
    dateFormatPluginMinuteFormatM: "Минуты без ведущего нуля (например, 5)",
    dateFormatPluginMinuteFormatMm: "Минуты с ведущим нулем (например, 05)",
    dateFormatPluginSecondsFormatS: "Секунды без ведущего нуля (например, 7)",
    dateFormatPluginSecondsFormatSs: "Секунды с ведущим нулем (например, 07)",
    dateFormatPluginDateSeparatorSlash: "/",
    dateFormatPluginDateSeparatorDot: ".",
    dateFormatPluginDateSeparatorDash: "-",
    dateFormatPluginDateSeparatorSpace: "Пробел",
    dateFormatPluginDateTimeOrderYmdHms: "год/месяц/день часы:минуты:секунды",
    dateFormatPluginDateTimeOrderDmyHms: "день/месяц/год часы:минуты:секунды",
    dateFormatPluginDateTimeOrderHmsYmd: "часы:минуты:секунды год/месяц/день",
    dateFormatPluginDateTimeOrderHmsDmy: "часы:минуты:секунды день/месяц/год",
    dateFormatPluginYearFormatTitle: "Год",
    dateFormatPluginMonthFormatTitle: "Месяц",
    dateFormatPluginDayFormatTitle: "День",
    dateFormatPluginHourFormatTitle: "Часы",
    dateFormatPluginMinuteFormatTitle: "Минуты",
    dateFormatPluginSecondsFormatTitle: "Секунды",
    regularBackupBlockH1: "Регулярное резервное копирование",
    mailRecipientTitle: "Почта получателя письма с ссылкой на скачивание резервной копии",
    dateFormatPluginDateSeparatorTitle: "Разделитель даты",
    dateFormatPluginDateTimeOrderTitle: "Порядок даты и времени",
    dateFormatPluginH1: "Форматирование даты и времени",
    customStyleH1: "Пользовательские стили",
    customGeneralCssTitle: "Пользовательские стили для приложения",
    customPublicCssTitle: "Пользовательские стили для публичных ссылок",
    dateFormatPluginResultFormat: "Результат форматирования",
    entitySettingsH1: "Общие настройки базы",
    mainPageSettingsH1: "Настройки главной страницы",
    homepageSetupLabel: "Формат главной страницы",
    availableOnExtended: "Доступно в тарифе Расширенный",
    selectKnowledgeBase: "Выбрать базу знаний",
    selectArticle: "Выбрать статью",
    baseSettingsOption: "Использовать настройки базы",
    favoritesOption: "Избранные статьи пользователя",
    singleArticleOption: "Статья детально",
    latestFromAllOption: "Последние добавленные статьи со всех баз",
    integrationsH1: "Интеграции",
    menuSettingsH1: "Настройка левого меню",
    enableLiveFeedPublication: "Разрешить публикацию в Живую ленту",
    showProjectBaseInMainListTitle: "Выводить в общем списке базы проектов",
    enableImageProxyProtection: "Включить проверку портала при запросе изображений",
    other: "Разное",
    publicSettingsBaseState: "Статьи",
    publicSettingsBaseSection: "Разделы",
    publicSettingsBaseDeleteLink: "Удалить ссылку",
    publicSettingsBaseDeleteEl: "эл.",
    publicSettingsBaseDeleteError: "'Ошибка при удаление публичной ссылки'.",
    sectionElementListCopyPublicLink: "Скопировать публичную ссылку",
    sectionElementListDeletePublicLink: "Удалить публичную ссылку",
    sectionElementListGetPublicLink: "Получить публичную ссылку",

    settingsSortBase: "Сортировка базы",
    settingsCurrent: "Текущее значение",
    settingsBackupBase: "Скачать бэкап базы",
    settingsRenameBase: "Переименовать",
    settingsBaseStyles: "Настроить стили",
    settingsExportBaseCsv: "Выгрузить базу в csv",
    settingsDeleteBase: "Удалить базу",
    settingsSortDialogTitle: "Сортировка базы",
    settingsDeleteBaseDialogTitle: "Удалить базу",
    settingsDeleteBaseWarning1: "При удалении базы вы также удаляете все данные, которые в них хранятся.",
    settingsDeleteBaseWarning2: "Все данные и все разделы будут удалены",
    settingsDeleteBaseWarningIrrevocably: "безвозвратно",
    settingsDeleteBaseConfirm: "Вы уверены, что хотите удалить базу",
    settingsDeleteBaseConfirmButton: "Да, удалить базу.",
    settingsRenameBaseDialogTitle: "Редактировать базу",
    settingsBaseStylesDialogTitle: "Редактировать стили базы",
    settingsBaseStylesTitleColor: "Цвет заголовка базы",

    accessNameBlockBlock: "Запрещён",
    accessNameBlockRead: "Чтение",
    accessNameBlockWrite: "Запись",
    accessNameBlockManage: "Управление",

    accessTextBlockBlock: "база пользователю недоступна, он не видит её в списке;",
    accessTextBlockRead: "пользователь может только читать базу;",
    accessTextBlockWrite: "пользователь имеет возможность добавлять статьи в базу;",
    accessTextBlockManage: "у пользователя полный контроль над базой, как у администратора.",
}
